import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path, Rect, Circle } from "react-native-svg"

const SvgChecklist = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={52} height={70} fill="none" viewBox="0 0 52 70" {...props}>
            <Path fill="#fff" d="M0 2h44a5 5 0 015 5v63H5a5 5 0 01-5-5V2z" />
            <Path fill={baseColors.green.pastel} d="M4 6h36a5 5 0 015 5v55H9a5 5 0 01-5-5V6z" />
            <Rect width={24} height={2} x={14} y={22} fill="#fff" rx={1} />
            <Rect width={26} height={2} x={14} y={32} fill="#fff" rx={1} />
            <Rect width={17} height={2} x={14} y={42} fill="#fff" rx={1} />
            <Rect width={26} height={2} x={14} y={52} fill="#fff" rx={1} />
            <Circle cx={9.525} cy={23.164} r={1} fill="#fff" />
            <Circle cx={9.525} cy={33.164} r={1} fill="#fff" />
            <Circle cx={9.525} cy={43.164} r={1} fill="#fff" />
            <Circle cx={9.525} cy={53.164} r={1} fill="#fff" />
            <Path
                fill={baseColors.green.dark}
                d="M17.05 5.115c0-.471.38-.853.852-.853H31.54c.47 0 .853.382.853.853v3.41H17.049v-3.41zM19.607.852c0-.47.381-.852.852-.852h8.525c.47 0 .852.382.852.852v3.41h-10.23V.852z"
            />
            <Circle cx={42} cy={57} r={10} fill={baseColors.orange.primary} />
            <Path
                fill="#fff"
                d="M39.577 56.021a.75.75 0 10-1.154.958l1.154-.958zM41.074 59l-.577.479.474.571.576-.468-.473-.582zm5.399-3.418a.75.75 0 00-.946-1.164l.946 1.164zm-8.05 1.397l2.074 2.5 1.154-.958-2.074-2.5-1.154.958zm3.124 2.603l4.926-4-.946-1.164-4.926 4 .946 1.164z"
            />
        </Svg>
    )
}

export default SvgChecklist
